export var FILE_TYPES = {
  IMG: ['image/png', 'image/jpeg', 'image/tiff', 'image/svg+xml', 'image/webp', 'image/bmp', 'image/gif', 'image/vnd.microsoft.icon'],
  PDF: ['application/pdf'],
  EXCEL: ['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'],
  WORD: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  POWERPOINT: ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
  ZIP: ['application/zip', 'application/x-zip-compressed'],
  TEXT: ['text/plain'],
  VIDEO: ['video/mp4', 'video/mpeg', 'video/ogg', 'video/mp2t', 'video/webm', 'video/3gpp', 'video/3gpp2']
};
export var ERROR_TYPES = {
  MAX_FILE_SIZE_EXCEEDED: 'MAX_FILE_SIZE_EXCEEDED',
  INVALID_FILE_TYPE: 'INVALID_FILE_TYPE',
  FILE_ALREADY_EXISTS: 'FILE_ALREADY_EXISTS',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR'
};
export var STATUS_CODES = {
  FILE_ALREADY_EXISTS: 409
};
export var MAX_FILE_SIZE = 20000000;